/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { t, calc6Ext, calcCommon } from '../../utils/calculatorTranslations'
import { PageContext } from '../../context/PageContextProvider'
import { useParams, Link } from 'react-router-dom'
import { useState, useContext, useEffect } from 'react'
import { Attention, Info, Calculator } from '../../icons'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import StepLine from '../../components/core/stepLine'
import jsPDF from 'jspdf'
import { font } from '../../utils/font'
import { getWatermarkDataUrl } from '../../utils/watermark'
import { calculateBusinessTrip2026 } from '../Calculator6/businessTripCalculator2026'

const formatCurrency = (val, currency = '₼') => {
  const num = Number(val) || 0
  const [int, dec] = num.toFixed(2).split('.')
  return int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + '.' + dec + ' ' + currency
}

const Result6 = ({ className }) => {
  const params = useParams()
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [calcData, setCalcData] = useState(null)

  useEffect(() => {
    (async () => {
      try {
        await PagesAPI.getMagazinePageInfo()
      } catch (e) {}

      let stored = null
      try {
        const raw = sessionStorage.getItem('businesstrip_result_2026')
        if (raw) stored = JSON.parse(raw)
      } catch (e) {}

      if (stored && stored.totalActualTripExpenses !== undefined) {
        setCalcData(stored)
      } else {
        // Fallback default calculation: Baku 4 days, 3 nights
        const defaultResult = calculateBusinessTrip2026({
          tripType: 'DOMESTIC',
          destinationKey: 'baku',
          startDate: '2026-10-01',
          endDate: '2026-10-04',
          hotelDocumentStatus: 'DOCUMENTED',
          actualHotelExpensePerNight: 87.50,
          transportExpenses: 50.0,
          tripWorkingDays: 2,
          monthlySalary: 1200,
        })
        setCalcData(defaultResult)
      }
      setLoad(true)
    })()
  }, [params])

  const steps = [
    {
      title: translate.calculation_type,
      text: translate.make_your_choice,
    },
    {
      title: translate.basic_information,
      text: translate.enter_info,
    },
    {
      title: translate.result,
      text: translate.ready,
    },
  ]

  const handleDownloadPDF = () => {
    if (!calcData) return

    const doc = new jsPDF()
    const watermark = getWatermarkDataUrl()
    if (watermark) {
      doc.addImage(watermark, 'PNG', 40, 70, 130, 130)
    }

    doc.addFileToVFS('Amiko-Regular.ttf', font)
    doc.addFont('Amiko-Regular.ttf', 'Amiko', 'normal')
    doc.setFont('Amiko')

    // Header
    doc.setFontSize(16)
    doc.setTextColor(15, 23, 42)
    doc.text('EZAMIYYƏ XƏRCLƏRİ HESABATI (2026)', 105, 22, { align: 'center' })

    doc.setFontSize(10)
    doc.setTextColor(100, 116, 139)
    doc.text('AR Nazirlər Kabinetinin 14 nömrəli Qərarı və Vergi Məcəlləsinin 98.3, 109.7 maddələri əsasında', 105, 29, { align: 'center' })

    let y = 42

    // Trip details table
    doc.setFontSize(11)
    doc.setTextColor(15, 23, 42)
    doc.text('1. Səfər Məlumatları və Qanuni Normalar', 14, y)
    y += 7

    doc.setFontSize(9)
    doc.setTextColor(51, 65, 85)
    doc.text(`Ezamiyyə istiqaməti: ${calcData.inputs.tripType === 'DOMESTIC' ? 'Ölkədaxili' : 'Xarici'} (${calcData.normData.name || calcData.normData.city})`, 14, y)
    y += 5
    doc.text(`Müddət: ${calcData.inputs.startDate} - ${calcData.inputs.endDate} (${calcData.totalCalendarDays} təqvim günü, ${calcData.hotelNights} gecə)`, 14, y)
    y += 5
    doc.text(`Gündəlik rəsmi norma: ${calcData.effectiveDailyNorm} ${calcData.currencyCode}/gün (Gündəlik: ${calcData.unitDailyExpenseNorm}, Mehmanxana: ${calcData.unitHotelNorm})`, 14, y)
    y += 5
    if (calcData.currencyCode !== 'AZN') {
      doc.text(`Tətbiq olunan məzənnə: 1 ${calcData.currencyCode} = ${calcData.currencyRate} AZN`, 14, y)
      y += 5
    }

    y += 6
    doc.setFontSize(11)
    doc.setTextColor(15, 23, 42)
    doc.text('2. Modul A: Ezamiyyə Xərclərinin Bölgüsü', 14, y)
    y += 7

    doc.setFontSize(9)
    doc.setTextColor(51, 65, 85)
    doc.text(`Gündəlik xərc (Per diem): ${calcData.totalDailyExpenses} ${calcData.currencyCode}`, 14, y)
    y += 5
    doc.text(`Mehmanxana / Qonaqlama: ${calcData.actualHotelExpensesClaimed || calcData.statutoryHotelExpenses} ${calcData.currencyCode} (${calcData.inputs.hotelDocumentStatus === 'DOCUMENTED' ? 'Sənədli' : 'Sənədsiz'})`, 14, y)
    y += 5
    doc.text(`Nəqliyyat xərcləri: ${calcData.transportExpenses} ${calcData.currencyCode}`, 14, y)
    y += 5
    doc.text(`Digər sənədli xərclər: ${calcData.otherDocumentedExpenses} ${calcData.currencyCode}`, 14, y)
    y += 5
    doc.setFontSize(10)
    doc.setTextColor(22, 111, 229)
    doc.text(`CƏMİ FAKTİKİ EZAMİYYƏ XƏRCİ: ${calcData.totalActualTripExpenses} ${calcData.currencyCode} (${calcData.totalTripExpensesAZN} AZN)`, 14, y)
    y += 8

    doc.setFontSize(11)
    doc.setTextColor(15, 23, 42)
    doc.text('3. Modul B: Saxlanılan Orta Əməkhaqqı (ƏM m.179)', 14, y)
    y += 7
    doc.setFontSize(9)
    doc.setTextColor(51, 65, 85)
    doc.text(`Ezamiyyəyə düşən iş günləri: ${calcData.modulB.tripWorkingDays} gün`, 14, y)
    y += 5
    doc.text(`Orta gündəlik əməkhaqqı: ${calcData.modulB.estimatedDailySalary} AZN`, 14, y)
    y += 5
    doc.text(`Cəmi saxlanılan əməkhaqqı: ${calcData.modulB.totalPreservedSalary} AZN`, 14, y)
    y += 8

    doc.setFontSize(11)
    doc.setTextColor(15, 23, 42)
    doc.text('4. Modul C: Vergi və Mənfəət Auditi (VM 98.3 və 109.7)', 14, y)
    y += 7
    doc.setFontSize(9)
    doc.setTextColor(51, 65, 85)
    doc.text(`İşçinin vergiyə cəlb olunan gəliri: ${calcData.modulC.taxableExcessIncomeEmployee} AZN (DVX izahı üzrə sənədli xərc vergidən azaddır)`, 14, y)
    y += 5
    doc.text(`İşəgötürənin gəlirdən çıxılmayan xərci (VM 109.7): ${calcData.modulC.nonDeductibleEmployerExpense} AZN`, 14, y)
    y += 5
    doc.text(`Avans mutabiqəti balansı: ${Math.abs(calcData.advanceBalance.balance)} AZN (${calcData.advanceBalance.resultType === 'REFUND_TO_EMPLOYER' ? 'İşçi qaytarmalıdır' : calcData.advanceBalance.resultType === 'PAYABLE_TO_EMPLOYEE' ? 'Şirkət ödəməlidir' : 'Dəqiq bərabərdir'})`, 14, y)
    y += 12

    doc.setFontSize(8)
    doc.setTextColor(148, 163, 184)
    doc.text('Bu hesabat BPG Consulting elektron ezamiyyə kalkulyatoru tərəfindən avtomatlaşdırılmış qaydada tərtib edilmişdir.', 105, 280, { align: 'center' })

    doc.save('Ezamiyye_Hesabat_2026.pdf')
  }

  if (!calcData) return null

  const currencySymbol = calcData.currencyCode === 'AZN' ? '₼' : calcData.currencyCode

  return load ? (
    <section className={`${styles.container} ${className || ''}`}>
      <Useful search={false} />
      <div className={styles.stepline}>
        <StepLine active={2} data={steps} />
      </div>

      <h1 className={styles.pageTitle}>Ezamiyyə Xərcləri Hesabatı (2026)</h1>

      {/* KPI Cards */}
      <div className={styles.resultGrid}>
        <div className={styles.statCard + ' ' + styles.heroCardA}>
          <div className={styles.cardLabel}>Cəmi Ezamiyyə Xərci (AZN)</div>
          <div className={styles.cardValue}>
            {formatCurrency(calcData.totalTripExpensesAZN, '₼')}
          </div>
          <div className={styles.cardSub}>
            {calcData.currencyCode !== 'AZN' && (
              <span>Faktiki valyutada: {formatCurrency(calcData.totalActualTripExpenses, currencySymbol)}</span>
            )}
            <div>{t(calc6Ext.allDocExpenses, language)}</div>
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.cardLabel}>Gündəlik Xərc (Per Diem)</div>
          <div className={styles.cardValue + ' ' + styles.primary}>
            {formatCurrency(calcData.totalDailyExpenses, currencySymbol)}
          </div>
          <div className={styles.cardSub}>
            {calcData.totalCalendarDays} gün × {calcData.unitDailyExpenseNorm} {currencySymbol}
          </div>
        </div>

        <div className={styles.statCard}>
          <div className={styles.cardLabel}>{t(calc6Ext.hotelExpense, language)}</div>
          <div className={styles.cardValue}>
            {formatCurrency(calcData.actualHotelExpensesClaimed || calcData.statutoryHotelExpenses, currencySymbol)}
          </div>
          <div className={styles.cardSub}>
            {calcData.hotelNights} gecə (Status: {calcData.inputs.hotelDocumentStatus === 'DOCUMENTED' ? 'Sənədli' : 'Sənədsiz'})
          </div>
        </div>

        <div className={styles.statCard + ' ' + styles.heroCardB}>
          <div className={styles.cardLabel}>Saxlanılan Əməkhaqqı (ƏM 179)</div>
          <div className={styles.cardValue}>
            {formatCurrency(calcData.modulB.totalPreservedSalary, '₼')}
          </div>
          <div className={styles.cardSub}>
            {calcData.modulB.tripWorkingDays} iş günü × {formatCurrency(calcData.modulB.estimatedDailySalary, '₼')}
          </div>
        </div>

        <div className={styles.statCard + ' ' + (calcData.advanceBalance.balance > 0 ? styles.heroCardC : '')}>
          <div className={styles.cardLabel}>{t(calc6Ext.advanceBalance, language)}</div>
          <div className={styles.cardValue + ' ' + (calcData.advanceBalance.balance > 0 ? styles.warning : styles.success)}>
            {formatCurrency(Math.abs(calcData.advanceBalance.balance), '₼')}
          </div>
          <div className={styles.cardSub}>
            {calcData.advanceBalance.resultType === 'REFUND_TO_EMPLOYER' && 'İşçi tərəfindən geri qaytarılmalıdır'}
            {calcData.advanceBalance.resultType === 'PAYABLE_TO_EMPLOYEE' && 'Şirkət işçiyə əlavə ödəməlidir'}
            {calcData.advanceBalance.resultType === 'EXACT_MATCH' && 'Avans tam xərcə bərabərdir (Kəsr yoxdur)'}
          </div>
        </div>
      </div>

      {/* Modul A: Ezamiyyə Xərcləri İcmalı */}
      <div className={styles.detailCard}>
        <div className={styles.cardHeader}>
          <h3>
            <Calculator width={20} height={20} />
            <span>Modul A: Qanuni və Faktiki Ezamiyyə Xərcləri Cədvəli</span>
          </h3>
          <span className={styles.headerBadge}>
            {calcData.inputs.tripType === 'DOMESTIC' ? 'Ölkədaxili' : 'Xarici'} — {calcData.normData.name || calcData.normData.city}
          </span>
        </div>

        <table className={styles.table}>
          <thead>
            <tr>
              <th>{t(calc6Ext.expenseItem, language)}</th>
              <th>{t(calc6Ext.legalBasisNorm, language)}</th>
              <th>Hesablama Parametrləri</th>
              <th style={{ textAlign: 'right' }}>Məbləğ ({currencySymbol})</th>
              {calcData.currencyCode !== 'AZN' && <th style={{ textAlign: 'right' }}>Məbləğ (AZN)</th>}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className={styles.bold}>Gündəlik xərc (Per diem)</td>
              <td>NK №14 (Ölkədaxili 30% / Xarici 40%)</td>
              <td>{calcData.totalCalendarDays} gün × {calcData.unitDailyExpenseNorm} {currencySymbol}</td>
              <td className={styles.right}>{formatCurrency(calcData.totalDailyExpenses, currencySymbol)}</td>
              {calcData.currencyCode !== 'AZN' && (
                <td className={styles.right}>{formatCurrency(calcData.totalDailyExpenses * calcData.currencyRate, '₼')}</td>
              )}
            </tr>
            <tr>
              <td className={styles.bold}>Mehmanxana / Qonaqlama</td>
              <td>
                {calcData.inputs.hotelDocumentStatus === 'DOCUMENTED' ? 'Təsdiqedici sənədlə (İnvoys)' : 'Sənədsiz (Hüquqi status tələb olunur)'}
              </td>
              <td>
                {calcData.hotelNights} gecə (Rəsmi norma: {calcData.unitHotelNorm} {currencySymbol})
              </td>
              <td className={styles.right}>
                {formatCurrency(calcData.actualHotelExpensesClaimed || calcData.statutoryHotelExpenses, currencySymbol)}
              </td>
              {calcData.currencyCode !== 'AZN' && (
                <td className={styles.right}>
                  {formatCurrency((calcData.actualHotelExpensesClaimed || calcData.statutoryHotelExpenses) * calcData.currencyRate, '₼')}
                </td>
              )}
            </tr>
            <tr>
              <td className={styles.bold}>Nəqliyyat xərcləri</td>
              <td>Bilet və transfer qəbzləri</td>
              <td>Sənədləşdirilmiş faktiki xərc</td>
              <td className={styles.right}>{formatCurrency(calcData.transportExpenses, currencySymbol)}</td>
              {calcData.currencyCode !== 'AZN' && (
                <td className={styles.right}>{formatCurrency(calcData.transportExpenses * calcData.currencyRate, '₼')}</td>
              )}
            </tr>
            {calcData.otherDocumentedExpenses > 0 && (
              <tr>
                <td className={styles.bold}>Digər sənədli xərclər</td>
                <td>Viza, sığorta, rüsumlar</td>
                <td>Sənədləşdirilmiş faktiki xərc</td>
                <td className={styles.right}>{formatCurrency(calcData.otherDocumentedExpenses, currencySymbol)}</td>
                {calcData.currencyCode !== 'AZN' && (
                  <td className={styles.right}>{formatCurrency(calcData.otherDocumentedExpenses * calcData.currencyRate, '₼')}</td>
                )}
              </tr>
            )}
            <tr className={styles.totalRow}>
              <td>CƏMİ EZAMİYYƏ XƏRCLƏRİ</td>
              <td>NK №14 və Q-01</td>
              <td>{calcData.totalCalendarDays} gün / {calcData.hotelNights} gecə</td>
              <td className={styles.right}>{formatCurrency(calcData.totalActualTripExpenses, currencySymbol)}</td>
              {calcData.currencyCode !== 'AZN' && (
                <td className={styles.right}>{formatCurrency(calcData.totalTripExpensesAZN, '₼')}</td>
              )}
            </tr>
          </tbody>
        </table>
      </div>

      {/* Modul B: Saxlanılan Əməkhaqqı */}
      <div className={styles.detailCard}>
        <div className={styles.cardHeader}>
          <h3>
            <Info width={20} height={20} />
            <span>Modul B: Əmək Məcəlləsinin 179-cu Maddəsi üzrə Saxlanılan Orta Əməkhaqqı</span>
          </h3>
          <span className={styles.headerBadge}>
            {calcData.modulB.averageSalaryMode === 'USER_PROVIDED_AVERAGE' ? 'Faktiki Orta Gündəlik' : 'Ştat Vəzifə Maaşı Rejimi'}
          </span>
        </div>

        <table className={styles.table}>
          <tbody>
            <tr>
              <td style={{ width: '40%' }}>Ezamiyyə dövrünə düşən iş günləri</td>
              <td className={styles.bold}>{calcData.modulB.tripWorkingDays} iş günü</td>
            </tr>
            <tr>
              <td>Orta gündəlik əməkhaqqı dərəcəsi</td>
              <td className={styles.bold}>{formatCurrency(calcData.modulB.estimatedDailySalary, '₼')} / gün</td>
            </tr>
            <tr className={styles.totalRow}>
              <td>İşçiyə ödəniləcək saxlanılan orta əməkhaqqı</td>
              <td className={styles.bold}>{formatCurrency(calcData.modulB.totalPreservedSalary, '₼')}</td>
            </tr>
          </tbody>
        </table>
        <p style={{ fontSize: '12px', color: '#64748b', marginTop: '10px' }}>
          * {calcData.modulB.averageSalaryNote}
        </p>
      </div>

      {/* Modul C: Vergi və Mənfəət Auditi */}
      <div className={styles.detailCard}>
        <div className={styles.cardHeader}>
          <h3>
            <Attention width={20} height={20} />
            <span>Modul C: Vergi və Mənfəət Auditi (VM 98.3, 102.1.14.2 və 109.7)</span>
          </h3>
          <span className={styles.headerBadge}>DVX Rəsmi İnzibati Mövqeyi</span>
        </div>

        <div className={styles.taxAuditGrid}>
          <div className={styles.auditItem}>
            <h4>İşçinin Vergiyə Cəlb Olunan Gəliri</h4>
            <div className={styles.value + ' ' + (calcData.modulC.taxableExcessIncomeEmployee === 0 ? styles.green : styles.amber)}>
              {formatCurrency(calcData.modulC.taxableExcessIncomeEmployee, '₼')}
            </div>
            <p>
              {calcData.modulC.taxableExcessIncomeEmployee === 0
                ? 'VM 98.3-ə əsasən, faktiki ezamiyyə xərcləri sənədləşdirildikdə normadan artıq olsa belə, işçinin gəlir vergisi və sosial sığorta bazasına aid edilmir.'
                : 'Sənədsiz olaraq normadan artıq ödənilmiş hissə işçinin muzdlu işlə əlaqədar gəliri hesab olunur və vergi/sosial tutulmalarına cəlb edilir.'}
            </p>
          </div>

          <div className={styles.auditItem}>
            <h4>İşəgötürənin Mənfəət Vergisində Gəlirdən Çıxılmayan Xərci</h4>
            <div className={styles.value}>
              {formatCurrency(calcData.modulC.nonDeductibleEmployerExpense, '₼')}
            </div>
            <p>
              VM 109.7-yə əsasən, sənədlərlə təsdiq olunsa belə rəsmi normadan artıq çəkilmiş xərclər şirkətin mənfəət vergisində gəlirdən çıxılan xərclərə aid edilmir.
            </p>
          </div>
        </div>
      </div>

      {/* Hüquqi Bildirişlər və Qanuni Status (Patches 1, 2, 3) */}
      <div className={styles.detailCard}>
        <div className={styles.cardHeader}>
          <h3>
            <Info width={20} height={20} />
            <span>Hüquqi Xəbərdarlıqlar və Qanuni Tələblər</span>
          </h3>
        </div>

        {calcData.legalNotices.hotelAdvisoryNotice && (
          <div className={styles.noticeBox}>
            <Info width={20} height={20} />
            <div>
              <strong>Mehmanxana Sənədsiz Rejimi (Q-01 və NK №14):</strong>
              <div>{calcData.legalNotices.hotelAdvisoryNotice}</div>
            </div>
          </div>
        )}

        <div className={styles.noticeBox}>
          <Info width={20} height={20} />
          <div>
            <strong>Avans Hesabatının Təqdim Edilmə Müddəti (Q-01 — 3 Təqvim Günü):</strong>
            <div>Son təhvil tarixi: <strong>{calcData.legalNotices.advanceReportDueDate}</strong>. {calcData.legalNotices.advanceReportNotice}</div>
          </div>
        </div>

        {calcData.legalNotices.weekendHolidayNotice && (
          <div className={styles.noticeBox + ' ' + styles.warning}>
            <Attention width={20} height={20} />
            <div>
              <strong>İstirahət və ya Bayram Günündə Səfər (Q-01 və ƏM m.164):</strong>
              <div>{calcData.legalNotices.weekendHolidayNotice}</div>
            </div>
          </div>
        )}
      </div>

      {/* Action Row */}
      <div className={styles.actionRow}>
        <Link to="/useful/calculator/6" className={styles.backBtn}>
          ← Parametrləri Dəyişdir
        </Link>
        <button onClick={handleDownloadPDF} className={styles.pdfBtn}>
          📥 Rəsmi PDF Hesabatını Yüklə
        </button>
      </div>
    </section>
  ) : (
    <Loading />
  )
}

export default Result6
